// Records the whole meeting's audio (host side) in 30s pieces and uploads them for the AI notes.
import { api, BACKEND_URL } from "./api";

export class MeetingAudio {
  constructor(mid, key) {
    this.mid = mid; this.key = key;
    this.session = Math.random().toString(36).slice(2, 10);
    this.seq = 0;
    this.q = Promise.resolve();
    this.ctx = new (window.AudioContext || window.webkitAudioContext)();
    this.dest = this.ctx.createMediaStreamDestination();
    this.src = new Map();
  }

  sync(streams) {
    const live = new Set();
    streams.filter(Boolean).forEach((s) => s.getAudioTracks().forEach((t) => {
      live.add(t.id);
      if (!this.src.has(t.id)) { const n = this.ctx.createMediaStreamSource(new MediaStream([t])); n.connect(this.dest); this.src.set(t.id, n); }
    }));
    [...this.src.keys()].filter((k) => !live.has(k)).forEach((k) => { try { this.src.get(k).disconnect(); } catch { /* noop */ } this.src.delete(k); });
  }

  start() {
    if (this.rec || !window.MediaRecorder) return false;
    const mime = ["audio/webm;codecs=opus", "audio/webm"].find((t) => MediaRecorder.isTypeSupported(t));
    if (!mime) return false;
    this.ctx.resume?.();
    this.rec = new MediaRecorder(this.dest.stream, { mimeType: mime, audioBitsPerSecond: 24000 });
    this.rec.ondataavailable = (e) => this.send(e.data, this.rec?.state === "inactive");
    this.rec.start(30000);
    // Tab closed without "Leave": tell the server to wrap up with what it already has.
    this.onHide = () => { if (!this.rec) return; const f = new FormData(); f.append("key", this.key); f.append("seq", String(this.seq++)); f.append("session", this.session); f.append("done", "true"); navigator.sendBeacon?.(`${BACKEND_URL}/api/public/meet/${this.mid}/audio`, f); };
    window.addEventListener("pagehide", this.onHide);
    return true;
  }

  send(blob, done = false) {
    const seq = this.seq++;
    this.q = this.q.then(() => {
      const f = new FormData();
      f.append("key", this.key); f.append("seq", String(seq)); f.append("session", this.session); f.append("done", done ? "true" : "false");
      if (blob?.size) f.append("file", blob, `part${seq}.webm`);
      return api.post(`/public/meet/${this.mid}/audio`, f).catch(() => {});
    });
    return this.q;
  }

  async stop() {
    const r = this.rec;
    if (!r) return;
    window.removeEventListener("pagehide", this.onHide);
    this.rec = null;
    if (r.state !== "inactive") {
      await new Promise((res) => { r.onstop = res; r.ondataavailable = (e) => { this.send(e.data, true); }; r.stop(); });
    } else this.send(null, true);
    await this.q;
    this.ctx.close().catch(() => {});
  }
}
